<nav class="navbar navbar-light justify-content-center" style="background-color: #ffffff;">
<!--  <a class="navbar-brand d-none d-lg-block"><img src="assets/img/Cual_es_txt.png" width="253" height="22"></a>-->

  <div class="container justify-content-center">
    <div class="row w-100 text-center">
      <div class="col-12">
        <p class="select-card-tittle">Selecciona tu Tarjeta BanCoppel</p>
      </div>
    </div>
  </div>

<!--  <a class="navbar-brand d-block d-lg-none"><img src="assets/img/Cual_es_txt@2x.png" width="253" height="22"></a>-->
</nav>


<!-- PARA PANTALLAS >= LARGE-->

<div class="navbar d-none d-lg-block justify-content-center" style="background-color: #F5F5FB; height: 202px">

  <div class="container">
    <div class="row w-100 justify-content-end pt-1">
      <div class="col-lg-7 pr-0 w-100 d-flex align-items-end justify-content-end text-right card-type-tittle">
        Productos de Crédito&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-lg-5 pr-0 w-100 d-flex align-items-start justify-content-start text-left card-type-tittle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Productos de Débito
      </div>
    </div>
  </div>


  <div class="container">
    <div class="row w-100 justify-content-center pt-0">

      <div class="col-lg-7 pr-0 w-100 d-flex align-items-end justify-content-end">


        <div class="row w-100 justify-content-end align-items-end text-right">
          <div class="col-lg-12 justify-content-end align-items-end text-right">
            <div class="card" *ngFor="let card of cardsCredit; let i = index">
              <div class="row justify-content-center nopadding align-items-center"
                   style="height: 84px; width: auto; background-color: #F5F5FB;">
                <div class="col-lg-12 justify-content-center nopadding">

                  <a (click)="selectCard(card.idTarjeta)" class="btn brightness">
                    <img src="{{card.urlImagen}}" alt="Card Back" width="137" height="88">
                  </a>
                </div>
              </div>
              <div class="row justify-content-end pt-3"
                   style="height: 61px; width: auto; background-color: #F5F5FB;">
                <div class="col-lg-12 justify-content-center text-center">
                  <span class="text-center cards-name">{{card.nombre}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-lg-5 pl-0 w-100 d-flex align-items-start justify-content-start">


        <div class="row w-100 justify-content-start align-items-start text-left">
          <div class="col-lg-12 justify-content-start align-items-start text-left">
            <div class="card" *ngFor="let card of cardsDebit; let i = index">
              <div class="row justify-content-center nopadding align-items-center"
                   style="height: 84px; width: auto; background-color: #F5F5FB;">
                <div class="col-lg-12 justify-content-center nopadding">

                  <a (click)="selectCard(card.idTarjeta)" class="btn brightness">
                    <img src="{{card.urlImagen}}" alt="Card Back" width="137" height="88">
                  </a>
                </div>
              </div>
              <div class="row justify-content-end pt-3"
                   style="height: 61px; width: auto; background-color: #F5F5FB;">
                <div class="col-lg-12 justify-content-center text-center">
                  <div class="row w-100">
                    <div class="col-12">
                      <span class="text-center cards-name">{{card.nombre}}</span>
                    </div>
                  </div>
                  <div class="row w-100 pt-0">
                    <div class="col-12 pt-0">
                      <span class="text-center card-subname">{{card.idTarjeta===1 ? 'Cuenta Efectiva Digital' : '&nbsp;'}}</span>
                    </div>
                  </div>
                </div>
              </div>
             <!-- <div class="row justify-content-end nopadding align-items-end"
                   style="height: 40px; width: auto; background-color: #F5F5FB;" *ngIf="card.idTarjeta===1">
                <div class="col-lg-12 justify-content-center text-center">
                  <span class="text-center cards-name">Digital</span>
                </div>
              </div>-->
            </div>
          </div>
        </div>

      </div>


    </div>
  </div>



<!--  <div class="container">
    <div class="row w-100 justify-content-center pt-0">

      <div class="col-lg-1 text-right align-items-center card-type-tittle">
      </div>
      <div class="col-lg-6 text-center align-items-center card-type-tittle">
        Productos de Crédito&nbsp;&nbsp;
      </div>
      <div class="col-lg-5 text-center align-items-center card-type-tittle">
        Productos de Débito&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>

    </div>
  </div>-->

  <!--<div class="row w-100 justify-content-center pt-1">

    <div class="col-lg-1 d-flex align-items-center"></div>

    <div class="col-lg-10 w-100 d-flex align-items-center justify-content-center">

      <div class="card" *ngFor="let card of cards; let i = index">
        <div class="row justify-content-center nopadding align-items-center" style="height: 84px; width: auto; background-color: #F5F5FB;">
          <div class="col-lg-12 justify-content-center nopadding">

            <a (click)="selectCard(card.idTarjeta)" class="btn brightness">
              <img  src="{{card.urlImagen}}" alt="Card Back"  width="137" height="88">
            </a>
          </div>
        </div>
        <div class="row justify-content-center nopadding align-items-center" style="height: 54px; width: auto; background-color: #F5F5FB;">
          <div class="col-lg-12 justify-content-center text-center">
            <span class="text-center cards-name">{{card.nombre}}</span>
          </div>
        </div>
      </div>

    </div>


    <div class="col-lg-1 d-flex align-items-center"></div>

  </div>-->

</div>


<!-- PARA PANTALLAS == SMALL-->

<div class="container d-none d-sm-block d-md-none ">

  <div class="row w-100 justify-content-center align-middle text-center">
    <div class="col-sm-12 card-type-tittle-mobile justify-content-center align-middle text-center">
      &nbsp;&nbsp;&nbsp;&nbsp;Productos de Crédito
    </div>
  </div>

  <div class="row w-100">
    <div class="col-sm-1"></div>
    <div class="col-10  w-100 d-flex align-items-center">

      <div class="card-mobile" *ngFor="let card of cardsCredit; let i = index">
        <div class="row justify-content-center align-items-center" style="height: 60px;">
          <div class="col-12 justify-content-center nopaddingm">
            <a  (click)="selectCard(card.idTarjeta)" class="btn brightness">
              <img  src="{{card.urlImagen}}" alt="Card Back"  width="80" height="53">
            </a>
          </div>
        </div>
        <div class="row w-100 d-flex justify-content-center nopaddingm" style="margin-left: 4px">
          <div class="col-12 justify-content-center text-center nopaddingm">
            <span class="text-center cards-namem">{{card.nombre}}</span>
          </div>
        </div>
      </div>

    </div>
    <div class="col-sm-1"></div>
  </div>


  <div class="row w-100 justify-content-center align-middle text-center">
    <div class="col-sm-12 card-type-tittle-mobile justify-content-center align-middle text-center">
      &nbsp;&nbsp;&nbsp;&nbsp;Productos de Débito
    </div>
  </div>

  <div class="row w-100">
    <div class="col-sm-1"></div>
    <div class="col-10  w-100 d-flex align-items-center">

      <div class="card-mobile" *ngFor="let card of cardsDebit; let i = index">
        <div class="row justify-content-center align-items-center" style="height: 60px;">
          <div class="col-12 justify-content-center nopaddingm">
            <a  (click)="selectCard(card.idTarjeta)" class="btn brightness">
              <img  src="{{card.urlImagen}}" alt="Card Back"  width="80" height="53">
            </a>
          </div>
        </div>
        <div class="row w-100 d-flex justify-content-center nopaddingm" style="margin-left: 4px">
          <div class="col-12 justify-content-center text-center nopaddingm">
            <span class="text-center cards-namem">{{card.nombre}}</span>
          </div>
        </div>
        <div class="row w-100 pt-0">
          <div class="col-12 pt-0">
            <span class="text-center card-subname">{{card.idTarjeta===1 ? 'Cuenta Efectiva Digital' : '&nbsp;'}}</span>
          </div>
        </div>
      </div>

    </div>
    <div class="col-sm-1"></div>
  </div>

</div>



<!-- PARA PANTALLAS == XSMALL-->
<div  class="container p-0 d-block d-sm-none text-center justify-content-center">

  <div class="row w-100 justify-content-center align-middle text-center">
    <div class="col-sm-12 card-type-tittle-mobile justify-content-center align-middle text-center">
      &nbsp;&nbsp;&nbsp;&nbsp;Productos de Crédito
    </div>
  </div>

  <div class="row w-100 justify-content-center pl-3">

    <div class="col-12 align-items-center">

      <div class="card-mobile" *ngFor="let card of cardsCredit; let i = index">

        <div class="row justify-content-center align-items-center" style="height: 60px;">
          <div class="col-12 justify-content-center text-center nopaddingm">
            <a  (click)="selectCard(card.idTarjeta)" class="btn brightness">
              <img  src="{{card.urlImagen}}" alt="Card Back"  width="70" height="44">
            </a>
          </div>
        </div>
        <div class="row w-100 d-flex justify-content-center nopaddingm" style="margin-left: 0px">
          <div class="col-12 justify-content-center text-center nopaddingm">
            <span class="text-center cards-namem">{{card.nombre}}</span>
          </div>
        </div>

      </div>

    </div>

  </div>


  <div class="row w-100 justify-content-center align-middle text-center">
    <div class="col-sm-12 card-type-tittle-mobile justify-content-center align-middle text-center">
      &nbsp;&nbsp;&nbsp;&nbsp;Productos de Débito
    </div>
  </div>

  <div class="row w-100 justify-content-center pl-3">

    <div class="col-12 align-items-center">

      <div class="card-mobile" *ngFor="let card of cardsDebit; let i = index">

        <div class="row justify-content-center align-items-center" style="height: 60px;">
          <div class="col-12 justify-content-center text-center nopaddingm">
            <a  (click)="selectCard(card.idTarjeta)" class="btn brightness">
              <img  src="{{card.urlImagen}}" alt="Card Back"  width="70" height="44">
            </a>
          </div>
        </div>
        <div class="row w-100 d-flex justify-content-center nopaddingm" style="margin-left: 0px">
          <div class="col-12 justify-content-center text-center nopaddingm">
            <span class="text-center cards-namem">{{card.nombre}}</span>
          </div>
        </div>
        <div class="row w-100 pt-0">
          <div class="col-12 pt-0">
            <span class="text-center card-subname">{{card.idTarjeta===1 ? 'Cuenta Efectiva Digital' : '&nbsp;'}}</span>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>



<!-- PARA PANTALLAS == MEDIANAS-->
<!--<div class="container d-none d-md-block d-lg-none">-->
<div class="navbar d-none d-md-block d-lg-none justify-content-center" style="background-color: #F5F5FB; height: 200px">

  <div class="container">
    <div class="row w-100 justify-content-end pt-1">
      <div class="col-md-7 pr-0 w-100 d-flex align-items-end justify-content-end text-right card-type-tittle">
        Productos de Crédito&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-5 pr-0 w-100 d-flex align-items-start justify-content-start text-left card-type-tittle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Productos de Débito
      </div>
    </div>
  </div>


  <div class="container">

    <div class="row w-100 justify-content-center pt-0">

      <div class="col-md-7  w-100 pr-0 d-flex align-items-end justify-content-end text-right">

        <div class="card" *ngFor="let card of cardsCredit; let i = index">
          <div class="row justify-content-center nopadding align-items-center"
               style="height: 84px; width: auto; background-color: #F5F5FB;">
            <div class="col-md-12 justify-content-center nopadding">

              <a (click)="selectCard(card.idTarjeta)" class="btn brightness">
                <img src="{{card.urlImagen}}" alt="Card Back" width="115" height="74">
              </a>
            </div>
          </div>
          <div class="row justify-content-end pb-4 align-items-center"
               style="height: 61px; width: auto; background-color: #F5F5FB;">
            <div class="col-md-12 justify-content-center text-center">
              <span class="text-center cards-name">{{card.nombre}}</span>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-5 w-100 pl-0 d-flex align-items-start justify-content-start text-left">

        <div class="card" *ngFor="let card of cardsDebit; let i = index">
          <div class="row justify-content-center nopadding align-items-center"
               style="height: 84px; width: auto; background-color: #F5F5FB;">
            <div class="col-md-12 justify-content-center nopadding">

              <a (click)="selectCard(card.idTarjeta)" class="btn brightness">
                <img src="{{card.urlImagen}}" alt="Card Back" width="115" height="74">
              </a>
            </div>
          </div>
          <div class="row justify-content-end pt-0 align-items-center"
               style="height: 61px; width: auto; background-color: #F5F5FB;">
            <div class="col-md-12 justify-content-center text-center">

                <div class="row w-100 d-flex">
                  <div class="col-md-12">
                    <span class="text-center cards-name">{{card.nombre}}</span>
                  </div>
                </div>
                <div class="row w-100 pt-0">
                  <div class="col-12 pt-0">
                    <span class="text-center card-subname-tablet">{{card.idTarjeta===1 ? 'Cuenta Efectiva Digital' : '&nbsp;'}}</span>
                  </div>
                </div>

            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

</div>


<div class="divider"></div>
